import Board from './Board';
export default Board;



// WEBPACK FOOTER //
// ./src/components/Board/index.js